import { faClone, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IDespachanteCodigo } from "../hooks/useCodigoDetran";
import {
  AcaoLink,
  BarraFundo,
  BarraProgresso,
  Codigo,
  Contagem,
  Mensagem,
  MenuContainer,
  SelectDespachante,
} from "./estilo";

interface Props {
  aberto: boolean;
  topo: number;
  carregandoDespachantes: boolean;
  aguardandoNovoCiclo: boolean;
  despachantes: IDespachanteCodigo[];
  idDespachante: number | null;
  selecionarDespachante(id: number): void;
  codigo: string;
  segundosRestantes: number;
  periodoSegundos: number;
  expirado: boolean;
  carregando: boolean;
  erro: string;
  permitirNovaTentativa: boolean;
  tentarNovamente(): void;
  copiarCodigo(): void;
}

export function CodigoDetran({
  aberto,
  topo,
  carregandoDespachantes,
  aguardandoNovoCiclo,
  despachantes,
  idDespachante,
  selecionarDespachante,
  codigo,
  segundosRestantes,
  periodoSegundos,
  expirado,
  carregando,
  erro,
  permitirNovaTentativa,
  tentarNovamente,
  copiarCodigo,
}: Props) {
  const segundos = Math.ceil(segundosRestantes);
  const percentual = Math.min(100, (segundosRestantes / (periodoSegundos || 30)) * 100);

  const exibirCodigo = !erro && !!codigo;
  const podeCopiar = exibirCodigo && !expirado && !carregando;

  const mensagem = montarMensagem();

  function montarContagem() {
    if (carregando) {
      return "Atualizando código...";
    }

    if (expirado) {
      return "Código expirado.";
    }

    return `Expira em aproximadamente ${segundos} segundo${segundos === 1 ? "" : "s"}`;
  }

  function montarMensagem() {
    if (erro) {
      return erro;
    }

    if (carregando && !codigo) {
      return aguardandoNovoCiclo
        ? "Aguardando o próximo ciclo do código..."
        : "Gerando código...";
    }

    if (carregandoDespachantes) {
      return "Carregando despachantes...";
    }

    if (!despachantes.length) {
      return "Nenhum despachante com dois fatores cadastrado.";
    }

    if (!idDespachante) {
      return "Selecione o despachante para gerar o código.";
    }

    return "";
  }

  return (
    <MenuContainer aberto={aberto} style={{ top: topo }}>
      <p>
        <strong>Código de dois fatores</strong>
      </p>
      <SelectDespachante
        value={idDespachante ?? ""}
        onChange={(evento) => selecionarDespachante(Number(evento.target.value))}
      >
        <option value="">Selecione o despachante</option>
        {despachantes.map((item) => (
          <option key={item.id} value={item.id}>
            {item.despachante}
          </option>
        ))}
      </SelectDespachante>

      {exibirCodigo && (
        <>
          <hr />
          <Codigo expirado={expirado}>{codigo}</Codigo>
          <BarraFundo>
            <BarraProgresso percentual={percentual} acabando={segundos <= 5} />
          </BarraFundo>
          <Contagem>
            {montarContagem()}
          </Contagem>
        </>
      )}

      {!!mensagem && <Mensagem erro={!!erro}>{mensagem}</Mensagem>}

      <hr />

      <AcaoLink
        desabilitado={!podeCopiar}
        onClick={() => podeCopiar && copiarCodigo()}
      >
        <FontAwesomeIcon icon={faClone} /> Copiar código
      </AcaoLink>
      {permitirNovaTentativa && (
        <AcaoLink onClick={tentarNovamente}>
          <FontAwesomeIcon icon={faRotateRight} /> Tentar novamente
        </AcaoLink>
      )}
    </MenuContainer>
  );
}
